// @symbo.ls/{windows,dropdown,tooltip} components (ModalRoot, ModalLayer,
// the dialog templates, DropdownRoot/Trigger + legacy Dropdown* shapes,
// TooltipRoot/Trigger + legacy Tooltip* shapes) are NOT re-exported here.
// The smbls runtime merges them into every context itself (prepareContext,
// smbls cedec5903 — same guard as @symbo.ls/polyglot; opt out per system
// with `context.windows|dropdown|tooltip = false`). A top-level bag
// re-export of an externalized specifier publishes as "" and that ""
// shadowed the real values in consumers (FRANK-PAGES-BAG-1,
// WORKSPACE-SHELL-UNDECLARED-IMPORTS-1); the plugin headers now forbid it.

export * from './ActivityChart.js'
export * from './AppControl.js'
export * from './NavbarRailControl.js'
// O1 — the ONE rendering of "what the AI can see" (AiContextBar + AiContextChip);
// feeds itself from buildAiAwareness. See the file header.
export * from './AiContextBar.js'

// Geex spatial-analytics archetypes (tickets/opus.md, tickets/brief-
// product-ui-direction.md "The geex reference frames — visual grammar") —
// plain-DOMQL chart primitives (no chart libs) generalizing the geex-arts
// iOS-16 poster language for analytics/home-widget/tickets/marketplace
// surfaces. items/ink/hue data-prop convention; see each file's header for
// its exact frame + contract.
export * from './GeexSegmentedBar.js'
export * from './GeexTonalBars.js'
export * from './GeexGridBars.js'
export * from './GeexRankedStack.js'
export * from './GeexValueRules.js'
export * from './GeexStackedColumn.js'
export * from './GeexBlobPercent.js'
export * from './UserProfile.js'
// Canonical signed-in-user account screen (profile fields, availability,
// equity, notifications, sessions, danger zone) — moved from
// workspace/components/MemberProfile.js (2026-08-15, tickets/opus.md) so
// canvas and workspace-shell consume ONE implementation. See profile.js
// (this package's pages/) for the page shell that mounts it.
export * from './MemberProfile.js'
export * from './ProfileAvailabilityGrid.js'
export * from './MarkdownPreview.js'
export * from './MenuPanel.js'
export * from './ContextDropdown.js'
export * from './PersonaPill.js'
export * from './UploadProgress.js'
export * from './EmptyState.js'
export * from './SwitchInput.js'
export * from './Skeleton.js'
export * from './LoadingSpinner.js'
export * from './ProgressBar.js'
export * from './PageBar.js'
export * from './ErrorState.js'
export * from './AiMenu.js'
export * from './AiPickerRow.js'
export * from './AiActionConfirmCard.js'
export * from './AiModePicker.js'
export * from './AiModelSwitcher.js'
export * from './AiSettingsPanel.js'
export * from './AiSettingsButton.js'
// The assistant chrome's two button primitives — one icon-button geometry
// for the drawer header and the composer bar, and the send control.
export * from './AssistantIconButton.js'
export * from './AssistantSendButton.js'
export * from './AiBridgeModal.js'
export * from './assistantSimone.js'
export * from './IntegrationScopePicker.js'
export * from './IntegrationConfigureForm.js'
export * from './MarketplaceRegistrarDomainPicker.js'
export * from './MarketplaceRegistrarSearchResult.js'
export * from './MarketplaceOAuthConnectButton.js'
export * from './Modal.js'
export * from './AppDialog.js'
export * from './AppMicroLabel.js'
export * from './AppKeycap.js'
export * from './AppCombobox.js'
export * from './PartyPicker.js'
export * from './AppField.js'
export * from './AppToolbar.js'
export * from './AppChoiceGroup.js'
export * from './AppFieldSegmented.js'
export * from './AppScrollRow.js'
export * from './AssistantModeChip.js'
// The composer's focus panel parts (DESIGN-COMPOSER-FOCUS-POPOVER-CONTEXT-
// INSPECT-1): the context switch, the mode switch, the panel's labels, verbs,
// groups and rows. (The composer's context pill is merged into the mode chip,
// AssistantModeChip `withContext` — Nika 2026-10-07.)
export * from './AiScopeSwitch.js'
export * from './AiModeSwitch.js'
export * from './AiPanelParts.js'
export * from './AppFieldColors.js'
export * from './AppFieldChips.js'
export * from './AppPageEyebrow.js'
export * from './DraftSwitcher.js'
export * from './IconNavbar.js'
export * from './Zoombar.js'
export * from './ResizeOverlay.js'
export * from './IconGridTypes.js'
export * from './CanvasPanel.js'
export * from './GridChooser.js'
export * from './DragHandler.js'
export * from './DsNavbar.js'
export * from './DeviceButtonSet.js'
export * from './ResponsiveSwitching.js'
export * from './CanvasVerticalNavbar.js'
export * from './ActiveContentSwitcher.js'
export * from './Feedback.js'
export * from './NavbarTooltipParent.js'
export * from './ResponsiveOverlay.js'
export * from './CodePreviewWithTitle.js'
export * from './CodeWithTitleAndButtons.js'
export * from './CodePreview.js'
export * from './PageTemplate.js'
export * from './DesignSystem.js'
export * from './Terminal.js'
export * from './Page.js'
export * from './Command.js'
export * from './TerminalWithTitle.js'
export * from './DesignSystemOptions.js'
export * from './InstallTabs.js'
export * from './SettingsSection.js'
export * from './InstallFooter.js'
export * from './InstallCdn.js'
export * from './InstallLiveExt.js'
export * from './InstallDomain.js'
export * from './ChromeExt.js'
export * from './InstallSymbolsJson.js'
export * from './InstallHero.js'
export * from './UsersTable.js'
export * from './Role.js'
export * from './SettingsTabs.js'
// InstallProvider.js re-exported below (near the other install/dashboard
// group additions) — the "requires @symbo.ls/react" note was stale: the
// file has zero real imports, `@symbo.ls/react` only appears inside a
// `value:` code-sample string shown to the user, not a module import.
export * from './DashboardTabs.js'
export * from './IntegrationsList.js'
export * from './InstallSync.js'
export * from './ServerPreview.js'
export * from './IntegrationItem.js'
export * from './SettingsFooter.js'
export * from './ProjectSection.js'
export * from './ProjectInfo.js'
export * from './SignupForm.js'
export * from './SignupLink.js'
export * from './LoginForm.js'
export * from './ItemPreview.js'
export * from './WaitlistForm.js'
export * from './RequestAccessButtons.js'
export * from './InviteForm.js'
export * from './LoginWindow.js'
export * from './YouAreConnected.js'
export * from './ResetPasswordsForm.js'
export * from './ResetEmailForm.js'
export * from './EmailConfirmationSuccess.js'
export * from './UsersTableCopy.js'
export * from './EmailConfirmationError.js'
export * from './EmailConfirmationTaken.js'
export * from './ConfirmSetPassword.js'
export * from './TutorialsPanel.js'
export * from './GovernanceFields.js'
export * from './EditorTools.js'
export * from './ChooseCanvas.js'
export * from './EditNavbar.js'
export * from './FilesSidebarSection.js'
export * from './FilesSidebarTitle.js'
export * from './FileSidebarSearch.js'
export * from './FilesSidebarList.js'
export * from './FileSidebarAddNewItem.js'
export * from './TutorialsRow.js'
export * from './CanvasProjectSidebar.js'
export * from './FilesSidebarListItem.js'
export * from './TutorialsRowItem.js'
export * from './DashboardSidebar.js'
export * from './FilesSidebarGrid.js'
export * from './NavbarTheming.js'
export * from './GlobalNotification.js'
export * from './SelectedArticlesPanel.js'
export * from './SelectRoleField.js'
export * from './SidebarSignupOverlay.js'
export * from './ActiveCanvasUsers.js'
export * from './CanvasConnectionBar.js'
export * from './ConnectionNavbar.js'
export * from './SaveCheckpointControl.js'
export * from './SelectedNavbar.js'
export * from './SidebarPricingOverlay.js'
export * from './Tests.js'
export * from './ExplorerSwitcher.js'
export * from './MainCanvasNavbar.js'
export * from './TextNavbar.js'
export * from './SearchBar.js'
export * from './CanvasSearch.js'
export * from './ZoomInNavbar.js'
export * from './ModesInNavbar.js'
export * from './CanvasSearchDropdown.js'
export * from './ThemesInNavbar.js'
export * from './CanvasSearchItem.js'
export * from './InsertPanel.js'
export * from './QuickAddPanel.js'
export * from './EnvItem.js'
export * from './DomainItem.js'
export * from './DropdownButton.js'
export * from './InviteDropdown.js'
export * from './ImportInInsert.js'
export * from './DataSourcesInInsert.js'
export * from './IntegrationsInInsert.js'
export * from './AssetsFromInsert.js'
export * from './LibraryFromInsert.js'
export * from './IconsFromInsert.js'
export * from './FontsFromInsert.js'
export * from './IconsGroup.js'
export * from './IconTemplateWithTooltip.js'
export * from './IconsPanelWidget.js'
export * from './IconTemplate.js'
export * from './IntegrationsItem.js'
export * from './IconsGroupWithCaption.js'
export * from './InsertSectionShadow.js'
export * from './LibraryNavbar.js'
export * from './InsertPanelIcons.js'
export * from './TutorialsInLearn.js'
export * from './Lottie.js'
export * from './InsertPanelLibrary.js'
export * from './BoxSizeItem.js'
export * from './TutorialItemInLearn.js'
export * from './DynamicIsland.js'
export * from './BoxSizeRow.js'
export * from './LearnPanel.js'
export * from './BoxSize.js'
export * from './BoxModelSubGrid.js'
export * from './BoxModelAside.js'
export * from './BoxModelMiddle.js'
export * from './BorderRadiusBox.js'
export * from './BorderRadius.js'
export * from './BoxModel.js'
export * from './LibraryItemInLearn.js'
export * from './LibrariesInLearn.js'
export * from './OnboardingPanel.js'
export * from './ActionNotification.js'
export * from './TutorialNotification.js'
export * from './TutorialNotificationStack.js'
export * from './IntroPanel.js'
export * from './ExampleItemInLearn.js'
export * from './ExamplesInLearn.js'
export * from './ExtensionCanvasNavbar.js'
export * from './UrlAddressBar.js'
export * from './LogoDropdown.js'
export * from './InstallExt.js'
export * from './DashboardNavbar.js'
export * from './CanvasPagesDropdown.js'
export * from './EnvsNavbar.js'
export * from './SharingNavbar.js'
export * from './ActiveSyncInPublish.js'
export * from './SyncSuggestionsInPublish.js'
export * from './ExportsInPublish.js'
export * from './PublishTools.js'
export * from './InlineSelect.js'
export * from './CompactIconButton.js'
export * from './MembersInInvite.js'
export * from './InviteFormInDropdown.js'
export * from './MagicLinkInInvite.js'
export * from './SharingPermissions.js'
export * from './MembersNavbar.js'
export * from './PublishNavbar.js'
export * from './MoreInsertMenu.js'
export * from './PreviewCanvasNavbar.js'
export * from './ComponentAddressBar.js'
export * from './DynamicNavbar.js'
export * from './TextNavbarButton.js'
export * from './MicroNavbar.js'
export * from './TextNavbarButtonDropdown.js'
export * from './PreviewModesMenu.js'
export * from './TutorialGifsNotificationStack.js'
export * from './TutorialGifNotification.js'
export * from './DragParagraph.js'
export * from './DragComponentsTutorial.js'
export * from './EditInNavbarMenu.js'
export * from './IntegrationsPanel.js'
export * from './ProjectCodeSidebar.js'
export * from './ProjectCodeData.js'
export * from './ProjectCodeSchema.js'
export * from './EditorPositionNavbar.js'
export * from './FnEditNavbar.js'
export * from './StateEditNavbar.js'
export * from './TutorialPillsNotification.js'
export * from './TutorialNotificationButtons.js'
export * from './TutorialGifNotificationSlider.js'
export * from './NavigationDots.js'
export * from './DangerZoneSection.js'
export * from './MembersTable.js'
export * from './Dropdown.MoreLearnMenu.js'
export * from './Dropdown.Envs.js'
export * from './Dropdown.QuickAdd.js'
export * from './Dropdown.MoreFilesMenu.js'
export * from './Dropdown.AssistantMenu.js'
export * from './Dropdown.Logo.js'
export * from './Dropdown.MoreModesMenu.js'
export * from './Dropdown.Share.js'
export * from './Dropdown.Publish.js'
export * from './SelectedLayerNavbar.js'
export * from './QuickEditor.js'
export * from './FileItem.js'
export * from './QuickEditorNavbar.js'
export * from './FilesSectionTitle.js'
export * from './FilesSection.js'
export * from './FilesSectionList.js'
// CodePreviewWidget moved to @symbo-ls/workspace-monaco — consumers that
// reference it by bare key must include the monaco context.js in their
// sharedLibraries.js so the DOMQL resolver can still find it. Keeping it
// in shared/ dragged monaco-editor (heavy + worker imports + .ttf fonts)
// into every consumer's bundle, including chrome-connect's panel.
export * from './CommandBar.js'
export * from './CommandPalette.js'
export * from './AppNavbar.js'
export * from './MainNavbar.js'
export * from './HeaderSearch.js'
export * from './HeaderTabs.js'
export * from './AppOrgSwitcher.js'
export * from './AppHeader.js'
export * from './AppShell.js'
// AppAssistant.js deleted 2026-06-02 — replaced by AssistantDrawer +
// simone Chat (see packages/shared/components/assistantSimone.js and
// packages/workspace/app.js shell-root mount). The magic-star toggle
// button moved to its own file so consumers that mount it via
// `AppAssistantToggle: {}` keep working without pulling the deleted
// drawer body.
export * from './AppAssistantToggle.js'
export * from './CanvasMessage.js'
export * from './CanvasHelpCard.js'
export * from './CommonCard.js'
// CommentThread — threaded discussion on ANY entity ref (VaultOS v2 §3.5),
// backed by the shared comments spine (sdk.execute('comments', …)). Exported
// here so ANY package mounts it by bare key — `CommentThread: { entityRef }` —
// without importing across a package boundary (FA001). The package's
// `sideEffects: true` is what keeps a string-key-only component alive through
// Parcel's tree-shake; do not flip it.
export * from './CommentThread.js'
// …and the row it mounts by key. Registered separately so a consumer can
// override the row without forking the thread (FA808).
export * from './CommentThreadItem.js'
export * from './AppPage.js'
export * from './AppCollectionPage.js'
export * from './AppCollectionSidebar.js'
// The visually hidden `h1` of a surface that shows no title (home, mail, the
// marketplace browse view, the agents board). See PageSrTitle.js.
export * from './PageSrTitle.js'
export * from './AppMain.js'
export * from './AppSidebar.js'
export * from './AppSidebarGroup.js'
export * from './AppSidebarRow.js'
export * from './AppTable.js'
export * from './AppStatusChip.js'
export * from './AppPagination.js'
export * from './PeopleSection.js'

export * from './Notifications.js'
export * from './Messenger.js'
export * from './ProjectCard.js'
export * from './AnalyticsNavbar.js'
export * from './RemoteTableCard.js'
export * from './RemoteRowTable.js'
export * from './RemoteRowEditor.js'
export * from './RemoteSchemaList.js'
export * from './InstallableRailItem.js'
export * from './InstallableRail.js'
export * from './InstallableModalStub.js'
export * from './MobileRailSheet.js'
export * from './WorkspaceSwitcher.js'
export * from './LangSwitcher.js'
// The ONE language control (chrome + registry options) and its bound
// interface-language form. Registered here so the workspace shell's admin
// surface can reach it by bare key through the shared-library merge.
export * from './LanguageSelectField.js'
export * from './ThemeToggle.js'
export * from './NotificationBell.js'
// The house tooltip for a control on the navbar: its side and its anchor
// follow the navbar's place (functions/navbarLayout.js).
export * from './NavbarTooltipTrigger.js'
export * from './DesignSystemBanners.js'
export * from './DesignSystemSummary.js'
export * from './DesignSystemSummaryMinimal.js'
export * from './FilesSidebarGettingStarted.js'
export * from './CanvasScaffold.js'
export * from './CanvasViewNav.js'
export * from './AgentAvatar.js'
export * from './PageSlotHeaderBtn.js'
export * from './VoiceOverlay.js'
export * from './VoiceStrip.js'
export * from './VoiceLog.js'
export * from './VoiceControls.js'
export * from './CascadeMenu.js'
export * from './InstallProvider.js'
export * from './_activeHighlight.js'
export * from './_touchTarget.js'
export * from './headerOverlayState.js'
export * from './OrderingItem.js'
export * from './ColorSelectWithTitle.js'
// White-label branded sign-in surface + its persona row (rendered by the
// shared signin page when an org branding record is present).
export * from './WhitelabelSignin.js'
export * from './WhitelabelAccent.js'
export * from './WhitelabelAuthWindow.js'
// The captcha slot both white-label onboarding panes mount.
export * from './WhitelabelTurnstile.js'
// the plate of the glyph language (dropdowns spec 2026-09-30 §4): launcher tiles, navbar tabs, the App strip
export * from './AppGlyphPlate.js'
